/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputUpdatePilotTeamSettings
 */
export interface InputUpdatePilotTeamSettings {
    /**
     * 
     * @type {boolean}
     * @memberof InputUpdatePilotTeamSettings
     */
    allowBomberMissions?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InputUpdatePilotTeamSettings
     */
    allowOpticMissions?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InputUpdatePilotTeamSettings
     */
    allowRadioMissions?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof InputUpdatePilotTeamSettings
     */
    craftNames: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InputUpdatePilotTeamSettings
     */
    droneUid: string;
    /**
     * 
     * @type {number}
     * @memberof InputUpdatePilotTeamSettings
     */
    packetRate?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof InputUpdatePilotTeamSettings
     */
    preferredChannels: Array<string>;
}

/**
 * Check if a given object implements the InputUpdatePilotTeamSettings interface.
 */
export function instanceOfInputUpdatePilotTeamSettings(value: object): boolean {
    if (!('craftNames' in value)) return false;
    if (!('droneUid' in value)) return false;
    if (!('preferredChannels' in value)) return false;
    return true;
}

export function InputUpdatePilotTeamSettingsFromJSON(json: any): InputUpdatePilotTeamSettings {
    return InputUpdatePilotTeamSettingsFromJSONTyped(json, false);
}

export function InputUpdatePilotTeamSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUpdatePilotTeamSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'allowBomberMissions': json['allowBomberMissions'] == null ? undefined : json['allowBomberMissions'],
        'allowOpticMissions': json['allowOpticMissions'] == null ? undefined : json['allowOpticMissions'],
        'allowRadioMissions': json['allowRadioMissions'] == null ? undefined : json['allowRadioMissions'],
        'craftNames': json['craftNames'],
        'droneUid': json['droneUid'],
        'packetRate': json['packetRate'] == null ? undefined : json['packetRate'],
        'preferredChannels': json['preferredChannels'],
    };
}

export function InputUpdatePilotTeamSettingsToJSON(value?: InputUpdatePilotTeamSettings | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'allowBomberMissions': value['allowBomberMissions'],
        'allowOpticMissions': value['allowOpticMissions'],
        'allowRadioMissions': value['allowRadioMissions'],
        'craftNames': value['craftNames'],
        'droneUid': value['droneUid'],
        'packetRate': value['packetRate'],
        'preferredChannels': value['preferredChannels'],
    };
}

